import React, { useEffect } from 'react'
import Home from '../Components/BrainiacBlitz/Home'
import Registration from '../Components/BrainiacBlitz/Registration'
import About from '../Components/BrainiacBlitz/About'
import Contact from '../Components/BrainiacBlitz/Contact'

const BrainiacBlitz = () => {
    useEffect(() => {
        document.title = "ACQC - BrainiacBlitz"
    });

    return (
        <div>
            <Home />
            <About />
            <Registration />
            <Contact />
        </div>
    )
}

export default BrainiacBlitz
